import {
  FormControl, FormLabel, InputAdornment, OutlinedInput,
} from '@material-ui/core';
import React from 'react';
import ErrorText from './ErrorText';

interface TextEntryProps {
  title?: string;
  placeholder?: string;
  units?: string;
  name: string;
  error?: boolean;
  errorText?: string;
  readonly?: boolean;
  value: string;
  handleChange?(event: React.ChangeEvent<HTMLInputElement>): void;
}

function TextEntryControl(props: TextEntryProps) : JSX.Element {
  const {
    title, placeholder, units, name, error, errorText, readonly, value, handleChange,
  } = props;

  return (
    <FormControl variant="outlined" component="fieldset" id={`text-entry-${name}-control`} fullWidth>
      {title && (
      <FormLabel
        component="legend"
        style={{
          color: 'black', fontWeight: 'bold', paddingBottom: '0.75em',
        }}
      >
        {title}
      </FormLabel>
      )}
      <OutlinedInput
        id={`text-entry-${name}`}
        placeholder={placeholder}
        endAdornment={units ?? <InputAdornment position="end">{units}</InputAdornment>}
        color="secondary"
        value={value}
        onChange={handleChange}
        name={name}
        error={error}
        style={{
          width: '250px',
        }}
        readOnly={readonly}
      />
      <ErrorText error={error || false} errorText={errorText || ''} />
    </FormControl>
  );
}

TextEntryControl.defaultProps = {
  title: undefined,
  placeholder: undefined,
  units: undefined,
  error: false,
  errorText: undefined,
  readonly: false,
  handleChange: undefined,
};

export default TextEntryControl;
